import React from 'react';
import { useI18n } from 'nordic/i18n';
import { Button } from '@andes/button';
import { misc } from '@credits-utils/constants';
import { trackAction } from '@/utils';
import SharedPropsContext from '../../../../../contexts/SharedProps';
import { getFaqSectionContent } from '../../content/faqSection';
import FaqItem from './components/FaqItem';
import Miscelanea from '../Miscelanea';

const { HIERARCHY } = misc;

const FaqSection = () => {
  const {
    openSeaUrl,
    tracks,
    siteId,
  } = React.useContext(SharedPropsContext);
  const { i18n } = useI18n();

  const { title, faqs, showMoreCta: { showMoreText, showLessText } } = getFaqSectionContent(
    { i18n, openSeaUrl, siteId },
  );
  const [faqsList, setFaqsList] = React.useState(faqs);
  const [showMore, setShowMore] = React.useState(false);

  const onToggle = id => {
    const newArray = faqsList.map(
      (item) => {
        if (item.id === id) {
          if (!item.isOpen) {
            const trackMelidata = {
              ...tracks.melidata.events.buyersPage.faqSection.viewFaq,
              event_data: {
                question: item.question,
              },
            };
            trackAction({
              melidata: trackMelidata,
            });
          }

          return {
            ...item,
            isOpen: !item.isOpen,
          };
        }

        return {
          ...item,
          isOpen: false,
        };
      },
    );

    setFaqsList(newArray);
  };

  return (
    <section className="faq-section">
      <Miscelanea />
      {title}
      <div>
        {faqsList.map((item, index) => (
          <FaqItem
            key={item.id}
            {...item}
            index={index}
            onToggle={onToggle}
            showMore={showMore}
          />
        ))}
      </div>

      <div className="faq-section__show-more">
        <Button
          className="andes-button andes-button-large"
          hierarchy={HIERARCHY.TRANSPARENT}
          onClick={() => setShowMore(!showMore)}
          data-testid="show-more-button"
        >
          {showMore ? showLessText : showMoreText}
        </Button>
      </div>
    </section>
  );
};

export default FaqSection;
